import { HEADERS } from "./headers.constants";

export const HEADERS_TRUSTED: HeadersInit = {
  ...HEADERS,
  Authorization: `Bearer ${process.env.APP_TRUSTED_KEY}`,
};
